import { c as _c } from "react/compiler-runtime";
import { FaroTextButton } from "@components/common/faro-text-button";
import { PALETTE_VARS } from "@styles/palette-vars";
import { DropdownButton } from "@components/dropdown/dropdown-button";
import { Text } from "@flat-ui";
import { assert } from "@faro-lotv/foundation";
import { Stack } from "@mui-wrapper";
import { useUserContext } from "@pages/account-settings/user-provider";
import { INTEGRATION_INFO } from "@src/constants/integrations-constants";
import { withEllipsisTwoLines } from "@styles/common-styles";
/** Component that renders a single row representing an integration. */
export function IntegrationRow(t0) {
  const $ = _c(32);
  const {
    integrationId,
    enabledIntegrationIds,
    onEnable,
    onDisable
  } = t0;
  const integration = INTEGRATION_INFO[integrationId];
  const IntegrationIcon = integration.icon;
  let t1;
  if ($[0] !== enabledIntegrationIds || $[1] !== integrationId) {
    t1 = enabledIntegrationIds.has(integrationId);
    $[0] = enabledIntegrationIds;
    $[1] = integrationId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isEnabled = t1;
  const {
    user
  } = useUserContext();
  assert(user, "User has to be defined to show email");
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      flexDirection: "row",
      alignItems: "center",
      paddingX: "1.25rem",
      justifyContent: "space-between",
      width: "100%",
      gap: "1rem",
      marginY: "1.75rem"
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      flexDirection: "row",
      gap: "1.875rem",
      alignItems: "center"
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      width: "2.5rem",
      height: "2.5rem"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== IntegrationIcon) {
    t5 = <IntegrationIcon sx={t4} />;
    $[6] = IntegrationIcon;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== integration.displayName) {
    t6 = <Text variant="heading20">{integration.displayName}</Text>;
    $[8] = integration.displayName;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      ...withEllipsisTwoLines,
      marginTop: "0.25rem"
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== integration.description || $[12] !== isEnabled || $[13] !== user) {
    t8 = isEnabled ? <var>{user.email}</var> : integration.description;
    $[11] = integration.description;
    $[12] = isEnabled;
    $[13] = user;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== integration.description || $[16] !== t8) {
    t9 = <Text variant="bodyS" title={integration.description} sx={t7}>{t8}</Text>;
    $[15] = integration.description;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t6 || $[19] !== t9) {
    t10 = <Stack>{t6}{t9}</Stack>;
    $[18] = t6;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t5) {
    t11 = <Stack sx={t3}>{t5}{t10}</Stack>;
    $[21] = t10;
    $[22] = t5;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== integrationId || $[25] !== isEnabled || $[26] !== onDisable || $[27] !== onEnable) {
    t12 = isEnabled ? <DropdownButton label="Connected" statusChipColor={PALETTE_VARS.success.main} actions={[{
      label: "Disconnect...",
      onClick: () => onDisable(integrationId)
    }]} /> : <FaroTextButton onClick={() => onEnable(integrationId)}>Connect</FaroTextButton>;
    $[24] = integrationId;
    $[25] = isEnabled;
    $[26] = onDisable;
    $[27] = onEnable;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t11 || $[30] !== t12) {
    t13 = <Stack sx={t2}>{t11}{t12}</Stack>;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
}